import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NovaagendaComponent } from './novaagenda/novaagenda.component';
import { DialogModule } from 'primeng/dialog';
import { AgendaService } from './services/agenda.service';
import { Router, RouterModule } from '@angular/router';
import { EditarAgendaComponent } from "./editar-agenda/editar-agenda.component";
import { LoadingModalComponent } from "../../../loading-modal/loading-modal.component";
import { AlertComponent } from "../../../alert/alert.component";
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    NovaagendaComponent,
    DialogModule,
    RouterModule,
    EditarAgendaComponent,
    LoadingModalComponent,
    AlertComponent,
    MatIconModule
  ],
  selector: 'app-agendas',
  templateUrl: './agendas.component.html',
  styleUrls: ['./agendas.component.scss']
})
export class AgendasComponent  implements OnInit {
  public openModalNovaAgenda: boolean = false;
  public listSchedules: Array<any> = [];
  public openModalEditSchedule: boolean = false;
  public selectedScheduleEdit: any;
  public actionDeleteSchedule: boolean = false;
  public scheduleSelectedToDelete!: any;

  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;

  constructor(private agendaService : AgendaService, private router: Router) { }

  ngOnInit() {

    this.handleListSchedules();
  }


  handleListSchedules(){
    this.agendaService.getAllAgendas().subscribe((response: any)=> {
      this.listSchedules = response;
    });
  }

  handleGoToDocumentationApi(){
    window.open("/api-documentation", "_blank")
  }




  openHandleNovaAgenda(){
    this.openModalNovaAgenda = true;
  }

  closeHandleNovaAgenda(){
    this.handleListSchedules();
    this.openModalNovaAgenda = false;
  }


  handleRedirectVisualizationSchedule(id: string){
    this.router.navigate([`/app/agendas/view/${id}`]);
  }

  handleEditSchedule(schedule: any){
    console.log("Editando schedule: ",schedule);
    this.openModalEditSchedule = true;
    this.selectedScheduleEdit = schedule;
  }

  handleCloseEditSchedule(){
    this.openModalEditSchedule = false;
    this.selectedScheduleEdit = undefined;
    this.handleListSchedules();
  }


  //This funtcion delete schedule
  handleDeleteSchedule(schedule: any){
    this.scheduleSelectedToDelete = schedule;
    
    this.actionDeleteSchedule = true;
  }

  handleCloseModalDeleteSchedule(){
    this.scheduleSelectedToDelete = undefined;
    this.actionDeleteSchedule = false;
  }

  handleActionDeleteSchedule(){
    this.loadingComponent.activeLoading();
    this.agendaService.deleteSchedule(this.scheduleSelectedToDelete.id).subscribe((response: any)=> {
      this.handleListSchedules();
      this.alertComponent.showAlert('Agenda deletada com sucesso', 'success');
      this.loadingComponent.inactiveLoading();
      this.handleCloseModalDeleteSchedule();
    }, (error: any)=> {
      console.log(error.response.message);
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert('Erro ao deletar agenda'+error.response.message , 'error');
    })
  }


  handleCopyUUIDSchedule(id: string){
    // Verifica se o navegador suporta a API de Clipboard
    if (navigator.clipboard) {
        // Usa a API de Clipboard para copiar o texto
        navigator.clipboard.writeText(id)
            .then(() => {
                this.alertComponent.showAlert('UUID copiado para a área de transferência', 'success');
                
            })
            .catch(err => {
                this.alertComponent.showAlert('Erro ao copiar UUID para a area de transferencia', 'error');
            });
    } else {
        // Caso a API de Clipboard não seja suportada, podemos usar um método alternativo
        const textArea = document.createElement('textarea');
        textArea.value = id;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.alertComponent.showAlert('UUID copiado para a área de transferência', 'success');
    }
  }

}
